import * as Sentry from "@sentry/nextjs";
import { Integrations } from "@sentry/tracing";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

const IS_SENTRY_ENABLED = publicRuntimeConfig.IS_SENTRY_ENABLED;
const SENTRY_ENVIRONMENT = publicRuntimeConfig.SENTRY_ENVIRONMENT;

import ApiConstants from "./constants/Api";
import {
  checkMutedExceptions,
  sentryDenyUrls,
  sentryIgnoreErrors,
} from "./utils/sentryHelpers";

const { SENTRY_DSN } = ApiConstants;

let initConfig = {
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  beforeSend: (event, hint) => {
    // In order to avoid seeing a lot of some errors on sentry dashboard because of external reasons
    // check if the exceptions being logged are muted
    if (!checkMutedExceptions(event, hint)) {
      //if not muted, proceed with logging
      return event;
    } else {
      //if muted, don't proceed
      return null;
    }
  },
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.2,
  denyUrls: sentryDenyUrls(),
  ignoreErrors: sentryIgnoreErrors(),
};

if (IS_SENTRY_ENABLED === "true") {
  Sentry.init(initConfig);
}
